export const validAccessCode = "76E37E58C494DCCB";
